<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">订单</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-container fluid>
      <v-row dense align="center">
        <v-col cols="7">
          <v-text-field label="订单号" v-model="form.business_order_id"></v-text-field>
        </v-col>
        <v-col cols="5">
          <v-select label="订单状态" v-model="form.status" :items="paymentStatusOptions" />
        </v-col>
      </v-row>
      <v-row dense align="center">
        <v-col cols="6">
          <v-text-field label="商户用户ID" type="text" v-model="form.customer_external_id"></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field label="艺爪用户ID" type="number" v-model="form.customer_id"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense align="center">
        <v-col cols="2">
          <span>日期</span>
        </v-col>
        <v-col cols="4">
          <v-text-field v-model="form.dt_created__gte"></v-text-field>
        </v-col>
        <v-col cols="1">
          <div>至</div>
        </v-col>
        <v-col cols="4">
          <v-text-field v-model="form.dt_created__lt"></v-text-field>
        </v-col>
      </v-row>
      <div class="d-flex justify-center">
        <v-btn class="mt-8 mb-4" color="primary" :width="128" @click="onQuery">查询</v-btn>
      </div>
    </v-container>
    <v-container fluid>
      <div
        class="mt-4 order-item"
        :key="payment.business_order_id"
        v-for="payment in paymentList"
        @click="onItemClick(payment.business_order_id)"
      >
        <div class="d-flex justify-space-between align-center">
          <div class="text--secondary payment-info-small">{{ payment.business_order_id }}</div>
          <div class="text--secondary payment-info-small">{{ formatPaymentChannel(payment) }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
          <div class="font-weight-bold">{{ payment.title }}</div>
          <div class="text-caption font-weight-bold">{{ statusNameOf(payment.status) }}</div>
        </div>
        <div class="d-flex justify-space-between align-center">
          <div class="text--secondary payment-info-small">
            <span class="d-inline-block">{{ payment.currency }}</span>
            <span class="d-inline-block ml-1">{{ formatPaymentPrice(payment) }}</span>
          </div>
          <div class="text--secondary payment-info-small">{{ payment.dt_created }}</div>
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import _ from 'lodash'
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { mdiChevronRight, mdiMagnify } from '@mdi/js'
import { PaymentStatus } from '@/plugins/payment'
import { formatPrice } from '@/plugins/price'
import { paymentStore } from '@/store/payment'
import { homeStore } from '@/store/home'
import { paymentChannelStore } from '@/store/paymentChannel'

function _parseDate(s) {
  return s ? new Date(s) : null
}

export default {
  name: 'PaymentOrderPage',
  components: { AppbarBackIcon },
  data() {
    return {
      mdiChevronRight,
      mdiMagnify,
      form: {
        business_order_id: null,
        status: null,
        customer_id: null,
        customer_external_id: null,
        dt_created__gte: null,
        dt_created__lt: null,
      },
    }
  },
  computed: {
    paymentStatusOptions() {
      const options = []
      _.forEach(_.toPairs(PaymentStatus.config), ([key, value]) => {
        if (!PaymentStatus.isSubStatus(value)) {
          options.push({
            text: key,
            value: value,
          })
        }
      })
      return options
    },
    paymentList() {
      return paymentStore.list
    },
  },
  async mounted() {
    await homeStore.doLoad()
  },
  methods: {
    formatPaymentPrice(payment) {
      return formatPrice(payment.total_price, payment.currency)
    },
    formatPaymentChannel(payment) {
      let channel = paymentChannelStore.get(payment.channel_id)
      if (_.isNil(channel)) {
        return payment.channel_id
      }
      return channel.name
    },
    statusNameOf(status) {
      let name = PaymentStatus.nameOf(_.parseInt(status))
      return name ? name : status
    },
    async onQuery() {
      let status_s = null
      if (!_.isNil(this.form.status)) {
        status_s = [_.parseInt(this.form.status)]
      }
      await paymentStore.doQuery({
        business_order_id: this.form.business_order_id,
        external_order_id: this.form.business_order_id,
        input_order_id: this.form.business_order_id,
        status_s: status_s,
        customer_id: this.form.customer_id,
        customer_external_id: this.form.customer_external_id,
        dt_created__gte: _parseDate(this.form.dt_created__gte),
        dt_created__lt: _parseDate(this.form.dt_created__lt),
        limit: 100,
      })
    },
    onItemClick(business_order_id) {
      this.$router.push({
        path: '/dash/payment-order-detail',
        query: { business_order_id: business_order_id },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.payment-info-small {
  font-size: 12px;
}
.order-item {
  padding: 8px;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>
